export default {
  "confirm-action.error.unexpected.title": "Something went wrong",
  "confirm-action.error.unexpected.message":
    "An unexpected error has occurred.",
  "confirm-action.error.wrong-device.title": "Wrong device",
  "confirm-action.error.wrong-device.message":
    "This link is only valid for the same device that started the request.",

  "confirm-action.partially-confirmed.title": "Successfully confirmed action",
  "confirm-action.partially-confirmed.message":
    "Continue with the device that initiated the action.",
};
